import React from "react";
import { cases, metrics, roleLine, summary, supportNotes } from "../content";
import { useReveal } from "./useReveal";

function Work() {
  const reveal = useReveal();

  return (
    <section id="work" className={`section section-work ${reveal.className}`} ref={reveal.ref}>
      <div className="shell">
        <p className="eyebrow">Work</p>
        <h2>Panasonic Energy</h2>
        <p className="work-lead">{summary.lead}</p>
        <p className="role-line">{roleLine}</p>

        <div className="cases">
          {cases.map((item) => (
            <article className="case" key={item.title}>
              <h3>{item.title}</h3>
              <div className="case-body">
                <p className="outcome">{item.outcome}</p>
                {item.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="support">
          <h3>Also in this role</h3>
          <ul>
            {supportNotes.map((note) => (
              <li key={note}>{note}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="metrics-band">
        <ul className="shell metrics">
          {metrics.map((item) => (
            <li key={item.title}>
              <span className="metric-title">{item.title}</span>
              <span className="metric-note">{item.note}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Work;
